module.exports = __webpack_public_path__ + "static/img/customer.f83dc02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer.png
// module id = mHF3
// module chunks = 1